// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 8nAON6P7zEMx
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicWebPortalButton.module.css"; // plasmic-import: 8nAON6P7zEMx/css
import CheckIcon from "./icons/PlasmicIcon__Check"; // plasmic-import: _oYn4Xiwl_vF/icon
import image12GJtvEduFrmcK from "./images/image12.png"; // plasmic-import: GJtvEDUFrmcK/picture

createPlasmicElementProxy;

export const PlasmicWebPortalButton__VariantProps = new Array("selected");

export const PlasmicWebPortalButton__ArgProps = new Array();

const $$ = {};

function PlasmicWebPortalButton__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.selected
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"checkboxGroupItem2"}
      data-plasmic-override={overrides.checkboxGroupItem2}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.checkboxGroupItem2,
        {
          [sty.checkboxGroupItem2selected]: hasVariant(
            $state,
            "selected",
            "selected"
          )
        }
      )}
    >
      <Stack__
        as={"div"}
        data-plasmic-name={"content3"}
        data-plasmic-override={overrides.content3}
        hasGap={true}
        className={classNames(projectcss.all, sty.content3)}
      >
        <div
          data-plasmic-name={"featuredIcon2"}
          data-plasmic-override={overrides.featuredIcon2}
          className={classNames(projectcss.all, sty.featuredIcon2)}
        >
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"52%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loading={"lazy"}
            src={{
              src: image12GJtvEduFrmcK,
              fullWidth: 64,
              fullHeight: 64,
              aspectRatio: undefined
            }}
          />
        </div>
        <div
          data-plasmic-name={"textAndSupportingText2"}
          data-plasmic-override={overrides.textAndSupportingText2}
          className={classNames(projectcss.all, sty.textAndSupportingText2, {
            [sty.textAndSupportingText2selected]: hasVariant(
              $state,
              "selected",
              "selected"
            )
          })}
        >
          <Stack__
            as={"div"}
            data-plasmic-name={"textAndSubtext2"}
            data-plasmic-override={overrides.textAndSubtext2}
            hasGap={true}
            className={classNames(projectcss.all, sty.textAndSubtext2)}
          >
            <div
              data-plasmic-name={"text2"}
              data-plasmic-override={overrides.text2}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text2
              )}
            >
              {"Enter Information via Web Portal"}
            </div>
            {false ? (
              <div
                data-plasmic-name={"subtext2"}
                data-plasmic-override={overrides.subtext2}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.subtext2
                )}
              >
                {"$10/month"}
              </div>
            ) : null}
          </Stack__>
          {false ? (
            <div
              data-plasmic-name={
                "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3"
              }
              data-plasmic-override={
                overrides.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3
              }
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3
              )}
            >
              {"Up to 10 users and 20GB individual data."}
            </div>
          ) : null}
        </div>
        <div
          data-plasmic-name={
            "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures4"
          }
          data-plasmic-override={
            overrides.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures4
          }
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures4
          )}
        >
          {
            "Add individual debtors by entering their information directly within the CollectWise portal"
          }
        </div>
      </Stack__>
      <div
        data-plasmic-name={"checkboxBase2"}
        data-plasmic-override={overrides.checkboxBase2}
        className={classNames(projectcss.all, sty.checkboxBase2, {
          [sty.checkboxBase2selected]: hasVariant(
            $state,
            "selected",
            "selected"
          )
        })}
      >
        {(hasVariant($state, "selected", "selected") ? true : false) ? (
          <CheckIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg, {
              [sty.svgselected]: hasVariant($state, "selected", "selected")
            })}
            role={"img"}
          />
        ) : null}
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  checkboxGroupItem2: [
    "checkboxGroupItem2",
    "content3",
    "featuredIcon2",
    "img",
    "textAndSupportingText2",
    "textAndSubtext2",
    "text2",
    "subtext2",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures4",
    "checkboxBase2",
    "svg"
  ],

  content3: [
    "content3",
    "featuredIcon2",
    "img",
    "textAndSupportingText2",
    "textAndSubtext2",
    "text2",
    "subtext2",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures4"
  ],

  featuredIcon2: ["featuredIcon2", "img"],
  img: ["img"],
  textAndSupportingText2: [
    "textAndSupportingText2",
    "textAndSubtext2",
    "text2",
    "subtext2",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3"
  ],

  textAndSubtext2: ["textAndSubtext2", "text2", "subtext2"],
  text2: ["text2"],
  subtext2: ["subtext2"],
  includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3: [
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3"
  ],

  includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures4: [
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures4"
  ],

  checkboxBase2: ["checkboxBase2", "svg"],
  svg: ["svg"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebPortalButton__ArgProps,
          internalVariantPropNames: PlasmicWebPortalButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebPortalButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "checkboxGroupItem2") {
    func.displayName = "PlasmicWebPortalButton";
  } else {
    func.displayName = `PlasmicWebPortalButton.${nodeName}`;
  }
  return func;
}

export const PlasmicWebPortalButton = Object.assign(
  // Top-level PlasmicWebPortalButton renders the root element
  makeNodeComponent("checkboxGroupItem2"),
  {
    // Helper components rendering sub-elements
    content3: makeNodeComponent("content3"),
    featuredIcon2: makeNodeComponent("featuredIcon2"),
    img: makeNodeComponent("img"),
    textAndSupportingText2: makeNodeComponent("textAndSupportingText2"),
    textAndSubtext2: makeNodeComponent("textAndSubtext2"),
    text2: makeNodeComponent("text2"),
    subtext2: makeNodeComponent("subtext2"),
    includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3:
      makeNodeComponent(
        "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures3"
      ),
    includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures4:
      makeNodeComponent(
        "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures4"
      ),
    checkboxBase2: makeNodeComponent("checkboxBase2"),
    svg: makeNodeComponent("svg"),
    // Metadata about props expected for PlasmicWebPortalButton
    internalVariantProps: PlasmicWebPortalButton__VariantProps,
    internalArgProps: PlasmicWebPortalButton__ArgProps
  }
);

export default PlasmicWebPortalButton;
/* prettier-ignore-end */
